import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Booking from './pages/Booking';
import Bookinggames from './pages/Booking_games';
import Confirmation from './pages/Confirmation';
import EditBooking from './pages/EditBooking';
import UpdatedConfirmation from './pages/UpdatedConfirmation';
import AdminDashboard from './pages/AdminDashboard';
import Aboutus from './pages/aboutus';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/bookinggames" element={<Bookinggames />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/editbooking" element={<EditBooking />} />
        <Route path="/updatedconfirmation" element={<UpdatedConfirmation />} />
        <Route path="/admindashboard" element={<AdminDashboard />} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;